import type { SvgComponent } from '@/types/SvgComponent';

export const InvertIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M11.7769 21.2185C16.7474 21.2185 20.7769 17.1891 20.7769 12.2185C20.7769 7.24794 16.7474 3.21851 11.7769 3.21851C6.80629 3.21851 2.77686 7.24794 2.77686 12.2185C2.77686 17.1891 6.80629 21.2185 11.7769 21.2185Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1165 3.80151C16.514 4.09103 19.9915 7.74766 19.9915 12.2185C19.9915 16.6893 16.514 20.345 12.1165 20.6345V3.80151Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
